import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const UploadIcon = ({ color = 'black', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path d="M9 14.9997L9 4.41388L12.2929 7.70677L13.7071 6.29256L8.70711 1.29256L8 0.585449L7.29289 1.29256L2.29289 6.29255L3.70711 7.70677L7 4.41388L7 14.9997L9 14.9997ZM0 17.9998V19.9998H16V17.9998H0Z" fill={color} stroke={color} />
    </svg>
  );
};

export default UploadIcon;
